import { t } from '../i18n/lingua.js';
import { SKU_ASSENTE, nomeArticolo } from '../pagine/Articoli.js';

/**
 * Un articolo trovato dalla ricerca, o quello già scelto.
 *
 * La descrizione da sola non basta: molti articoli si somigliano, e chi
 * cerca per numero BC («pfp-») non vedeva il numero che aveva scritto
 * (Antonio, 27 ottobre 2026). Sotto la descrizione vanno il numero in
 * Business Central e lo SKU, ognuno col suo nome.
 */
export function VoceArticolo({
  articolo,
}: {
  articolo: { id: number; description: string | null; sku: string | null; bcNumber?: string | null };
}) {
  const sku = articolo.sku && articolo.sku !== SKU_ASSENTE ? articolo.sku : null;
  return (
    <span className="voce-articolo">
      <span className="voce-articolo-nome">
        {nomeArticolo({ ...articolo, description: articolo.description ?? '', sku: articolo.sku ?? '' })}
      </span>
      <span className="voce-articolo-codici">
        <span>
          {t('Numero BC')} <span className="num">{articolo.bcNumber || '—'}</span>
        </span>
        <span>
          {t('SKU')} <span className="num">{sku ?? '—'}</span>
        </span>
      </span>
    </span>
  );
}
